import React from 'react'

const Header = ({title}) => {
  return (
    <header className='Header'>
      <h2>{title}</h2>
    </header>
  )
}

export default Header